"use client";
import Close from "@/components/icons/Close";
import { ColumnsIcon } from "@/components/icons/Columns";
import Plus from "@/components/icons/Plus";
import Button from "@/components/ui/Button";
import useDevice from "@/hooks/useDevice";
import { FormattedFilterGroup } from "@/lib/depict/filters";
import { DepictSortOption, FilterData } from "@/lib/depict/types";
import { useUrlSearchParams } from "@frend-digital/ui/next";
import clsx from "clsx";
import { Suspense } from "react";
import FilterButton from "../PlpButtons/FilterButton";
import { searchParamOptions } from "../PlpModals/Filter/FilterModal";
import SortModal from "../PlpModals/Sort";
import styles from "./index.module.css";

type Props = {
  productCount?: number;
  appliedFilters?: FilterData[];
  filters: FormattedFilterGroup[];
  gridSize: number;
  setGridSize: React.Dispatch<React.SetStateAction<number>>;
  sorts: DepictSortOption[] | undefined;
};

const PlpTopBar = ({
  productCount,
  appliedFilters,
  setGridSize,
  gridSize,
  sorts,
}: Props) => {
  const searchParams = useUrlSearchParams(searchParamOptions);
  const hasTags = appliedFilters && appliedFilters.length > 0;
  const filterCount = appliedFilters?.length ?? 0;

  /*   const sortByDisplay = sortOrder?.active?.display;
  const hasSortBy = sortOrder?.sortOrder.length > 0; */

  const { mobile } = useDevice();

  return (
    <section className={styles.filters}>
      <div className={styles.wrap}>
        <div className={styles.tagWrapper}>
          {hasTags && (
            <div className={styles.tags}>
              {appliedFilters?.map(tag => {
                if (!Array.isArray(tag.data)) return null;
                return tag?.data?.map((data, i) => (
                  <span
                    tabIndex={1}
                    className={styles.tag}
                    key={i}
                    onClick={() => {
                      const newValues = searchParams
                        .getAll(tag.field)
                        .filter(v => v !== data);
                      searchParams.delete(tag.field);
                      newValues.forEach(v => searchParams.append(tag.field, v));
                    }}
                    role="button"
                  >
                    <span>{data}</span>
                    <Close />
                  </span>
                ));
              })}
            </div>
          )}
        </div>
        <div className={styles.count}>
          {productCount} {productCount && productCount > 1 ? "items" : "item"}
        </div>

        <div className={styles.filtersBar}>
          <FilterButton>
            <span>
              <span className={clsx(hasTags && styles.bold)}>
                Filter
                {filterCount > 0 && <span>({filterCount})</span>}
              </span>
              {!hasTags && <Plus />}
            </span>
          </FilterButton>
        </div>
        <div className={styles.sortBy}>
          <Suspense>
            <SortModal sorts={sorts} />
          </Suspense>
        </div>

        <div className={styles.colbuttons}>
          <Button
            mode="toggle"
            title={mobile ? "Two columns" : "Four columns"}
            onClick={() => {
              setGridSize(4);
            }}
          >
            <div
              className={clsx(
                styles.colbutton,
                gridSize === 4 && styles.active,
              )}
            >
              <ColumnsIcon className="desktop" columns={4} />
              <ColumnsIcon className="mobile" columns={2} />
            </div>
          </Button>

          <Button
            mode="toggle"
            title={mobile ? "Single column" : "Three columns"}
            onClick={() => {
              setGridSize(3);
            }}
          >
            <div
              className={clsx(
                styles.colbutton,
                gridSize === 3 && styles.active,
              )}
            >
              <ColumnsIcon className="desktop" columns={3} />
              <ColumnsIcon className="mobile" columns={1} />
            </div>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PlpTopBar;
